import React from 'react';
import { useTranslation } from 'react-i18next';
import MonacoEditor from '@monaco-editor/react';

const formatTimestamp = timestamp => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  const month = date.toLocaleString('en-US', { month: 'long' });
  const day = date.getDate();
  const time = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  return `${month} ${day}, at ${time}`;
};

const CodeEditor = ({ code, curr_submission }) => {
  const { t } = useTranslation('practice_tests');
  return (
    <div
      data-test-id="code-editor"
      data-specific-id="submission-code-editor"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
        }}
        data-test-id="code-editor-header"
        data-specific-id="editor-header-section"
      >
        <h3
          style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}
          data-test-id="code-editor-title"
          data-specific-id="editor-title"
        >
          {t('practice_tests.test_result.code_editor')}
        </h3>
        <span
          style={{ fontSize: '14px', color: '#6B7280' }}
          data-test-id="submission-time"
          data-specific-id="submission-creation-date"
        >
          {t('practice_tests.test_result.submission_time', {
            time: formatTimestamp(curr_submission.creation_date || curr_submission.submitted_at),
          })}
        </span>
      </div>

      {/* Monaco Editor */}
      <div
        style={{
          border: '1px solid #E5E7EB',
          borderRadius: '4px',
          overflow: 'hidden',
          background: '#FFFFFF',
        }}
        data-test-id="monaco-editor-container"
        data-specific-id="monaco-editor-wrapper"
      >
        <MonacoEditor
          height="460px"
          language={curr_submission.language === 'python3' ? 'python' : curr_submission.language}
          value={code}
          theme="vs-light"
          options={{
            readOnly: true,
            minimap: { enabled: false },
            fontSize: 14,
            lineNumbers: 'on',
            scrollBeyondLastLine: false,
            automaticLayout: true,
          }}
        />
      </div>
    </div>
  );
};

export default CodeEditor;
